module.exports = {"350702001":"梅山街道","350702002":"黄墩街道","350702003":"紫云街道","350702004":"四鹤街道","350702005":"水南街道","350702006":"水东街道","350702100":"来舟镇","350702101":"樟湖镇","350702102":"夏道镇","350702103":"西芹镇","350702104":"峡阳镇","350702105":"南山镇","350702106":"大横镇","350702107":"王台镇","350702108":"太平镇","350702109":"塔前镇","350702110":"茫荡镇","350702111":"洋后镇","350702112":"炉下镇","350702200":"巨口乡","350702202":"赤门乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350702.json
// module id = 1123
// module chunks = 0